module.exports = __webpack_public_path__ + "static/img/head-h2.f157ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/head-h2.png
// module id = h+j2
// module chunks = 1